// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__PFm4Q","tab":"Tabs_tab__3jTX4","tabActive":"Tabs_tabActive__3xgbn"};